import styled from "styled-components";

const Container = styled.div``;

export { Container };

export default { Container };
